import { request } from "./http";

export const listPayments = (params?: { status?: 'pending' | 'paid' }) =>
  request<import("../types").Payment[]>("/api/payments" + (params?.status ? `?status=${params.status}` : ""));

export const createPayment = (body: { client_id: number | string; amount_cents: number; paid_at?: string; notes?: string | null }) =>
  request<import("../types").Payment>("/api/payments", { method: "POST", body: JSON.stringify(body) });

export const updatePayment = (
  id: number,
  body: Partial<{ status: 'pending' | 'paid'; paid_at: string; total_amount_cents: number }>
) => request<Partial<import("../types").Payment>>(`/api/payments/${id}`, { method: "PUT", body: JSON.stringify(body) });

export const deletePayment = (id: number) =>
  request<void>(`/api/payments/${id}`, { method: "DELETE" });

// Expenses
export const listExpenses = () =>
  request<any[]>("/api/expenses");

export const createExpense = (data: any) =>
  request<any>("/api/expenses", { method: "POST", body: JSON.stringify(data) });

export const updateExpense = (id: number, data: any) =>
  request<any>(`/api/expenses/${id}`, { method: "PUT", body: JSON.stringify(data) });

export const deleteExpense = (id: number) =>
  request<any>(`/api/expenses/${id}`, { method: "DELETE" });
